<template>
  <div class="dinner-item">
    <img style="width: 26px; height: 14px; margin-right: 4px" src="@/assets/logo-small.png" />
    <span>{{ flightItem.flightNo }}</span>
    <span style="padding: 0  0 0 10px;">{{ flightItem.depDate }}</span>
    <span style="margin: 0 10px">空客A{{ flightItem.aircraftType }}</span>
    <span>{{ flightItem.mealServiceDesc }}</span>
  </div>
</template>

<script>
export default {
  name: "DinnerItem",
  props: {
    flightItem: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="less" scoped>
.dinner-item {
  display: flex;
  align-items: center;
  line-height: 30px;
}
</style>
